const translations = {
  id: {
    sys_active: 'Sistem Aktif',
    cctv_online: 'CCTV Online',
    nav_beranda: 'Dashboard',
    nav_vision:  'Vision',
    nav_intel:   'Profiling',
    nav_datacenter: 'Datacenter',
    page_beranda: 'Dashboard',
    page_vision:  'Vision: Deteksi Orang dan Kendaraan',
    page_intel:   'Profiling: Penggalian Data Mendalam',
    page_datacenter: 'Datacenter: Kelola Orang dan Kendaraan',
    cmd_sub: 'Ikhtisar dan CCTV Aktif',
    nv_sub: 'Deteksi Orang dan Kendaraan',
    ni_sub: 'Penggalian Data Mendalam',
    zone: '',
    connected: 'TERHUBUNG',
    drag_hint: 'Seret ikon',
    drag_hint2: 'di header panel untuk memindahkan posisi',
    stat_cameras: 'Kamera Online',
    stat_suspects: 'Tersangka Aktif',
    stat_alerts: 'Peringatan Belum Tertangani',
    stat_incidents: 'Insiden Hari Ini',
    sub_cameras: '1 offline (Pluit-02)',
    sub_suspects: '3 DPO dalam sistem',
    sub_alerts: 'Menunggu tindakan',
    sub_incidents: '2 aktif · 1 selesai',
    panel_stats: 'Status Sistem',
    panel_map: 'Peta Kota & Deck',
    panel_alerts: 'Notifikasi',
    panel_cctv: 'Monitor CCTV',
    active_alerts: 'alert aktif',
    see_all: 'Lihat semua',
    tab_feed: 'Monitor CCTV',
    tab_camera: 'Kamera Perangkat',
    tab_upload: 'Unggah File',
    tab_stream: 'Jaringan CCTV',
    drop_photo: 'Seret foto ke sini atau klik untuk pilih',
    drop_multi: 'Seret satu atau banyak foto / video',
    drop_multi_hint: 'JPG / PNG / WebP atau MP4 / MOV / WebM · Maks 500MB · Multi-file otomatis batch scan',
    file_hint: 'JPG, PNG, WebP · Maks 10MB',
    panel_log: 'Log Aktivitas',
    panel_subjects: 'Subjek Terdeteksi',
    subjects_empty: 'Belum ada subjek terdeteksi',
    session_label: 'sesi',
    item_label: 'item',
    clear_session: 'clear',
    clear_session_tip: 'Clear log sesi (DB tetap tersimpan)',
    cell_scan_on: 'Nyalakan',
    cell_scan_off: 'Matikan',
    neo_proactive_sub: 'Memantau Aktif',
    neo_input_ph: 'Tanya N.E.O...',
    add_camera: 'Tambah Kamera',
    close_video: 'Tutup video',
    upload_other: 'Upload file lain',
    no_data: 'Belum tersedia',
    last_seen: 'Terakhir Terdeteksi',
    batch_empty_title: 'Upload banyak foto sekaligus',
    batch_empty_hint: 'Seret & lepas foto dari rekaman CCTV, drone, atau surveilans',
    proc_failed: 'Gagal diproses',
    open_file: 'Buka file',
    cam_title_toggle: 'Klik untuk toggle ONLINE/OFFLINE',
    cam_title_edit_name: 'Klik untuk edit nama',
    cam_title_edit_loc: 'Klik untuk edit lokasi',
    cam_title_delete: 'Hapus kamera',
    rec_title_delete: 'Hapus rekaman',
    rec_empty: 'Belum ada rekaman',
    veh_empty: 'Belum ada kendaraan terdaftar',
    veh_title_delete: 'Hapus kendaraan',
    veh_select_type: 'Pilih tipe',
    sel_video_or_photo: 'Pilih video atau foto untuk diupload',
    search_name_nik: 'Cari nama atau NIK...',
    pen_title_delete: 'Hapus penduduk + semua kendaraan + foto + embedding',
    name_full_ph: 'Nama Lengkap',
    cam_name_ph: 'Nama Kamera *',
    cam_loc_ph: 'Lokasi',
    save: 'Simpan',
    cancel: 'Batal',
    gate_intel: 'SUBJECT PROFILING: Data Penduduk',
    gate_dc: 'DATACENTER: Kelola Data',
    btn_penduduk: 'Penduduk',
    btn_kendaraan: 'Kendaraan',
    btn_add_penduduk: 'Tambah Penduduk',
    btn_add_kendaraan: 'Tambah Kendaraan',
    btn_save_kendaraan: 'Simpan Kendaraan',
    add_penduduk_first: 'Tambah penduduk dulu',
    add_kendaraan_new: 'Tambah kendaraan baru',
    template_csv: 'Template CSV',
    btn_import_csv: 'Impor CSV',
    sync_db_ai: 'SINKRON DATABASE AI',
    sync_idle: 'SIAP',
    sync_running: 'SINKRON',
    sync_done: 'SELESAI',
    sync_error: 'GAGAL',
    label_penduduk: 'penduduk',
    label_foto: 'foto',
    label_emb: 'emb',
    select_resident: 'Pilih penduduk untuk edit',
    citizen_data: 'Data Penduduk',
    cctv_cameras: 'Kamera CCTV',
    add_camera_btn: 'Tambah Kamera',
    save_changes: 'Simpan',
    delete_failed: 'Gagal hapus',
    upload_cctv_label: 'Unggah Video / Foto CCTV',
    fld_tempat_lahir: 'Tempat Lahir',
    fld_tgl_lahir: 'Tgl Lahir',
    fld_jenis_kelamin: 'Jenis Kelamin',
    fld_alamat: 'Alamat Lengkap',
    fld_rt_rw: 'RT/RW',
    fld_kel: 'Kel/Desa',
    fld_kec: 'Kecamatan',
    fld_kota: 'Kota/Kabupaten',
    fld_agama: 'Agama',
    fld_status_kawin: 'Status Perkawinan',
    fld_pekerjaan: 'Pekerjaan',
    fld_kewarga: 'Kewarganegaraan',
    fld_gol_darah: 'Gol. Darah',
    fld_status_intel: 'Status Intelijen',
    fld_catatan_fisik: 'Catatan Fisik',
    fld_no_plat: 'Plat Nomor *',
    fld_no_plat_simple: 'No. Plat',
    fld_merk_model: 'Merk / Model',
    fld_tipe: 'Tipe',
    fld_warna: 'Warna',
    fld_tahun: 'Tahun',
    fld_masa_stnk: 'Masa Berlaku STNK',
    fld_no_rangka: 'No. Rangka',
    fld_no_mesin: 'No. Mesin',
    fld_catatan_visual: 'Catatan Visual',
    fld_nik_pemilik: 'NIK Pemilik',
    fld_nik: 'NIK',
    cat_visual_ph: 'Stiker merah di pintu, kaca gelap...',
    no_camera_yet: 'Belum ada kamera. Klik Tambah Kamera.',
    success_label: 'Berhasil',
    failed_label: 'Gagal',
    success_imported: 'Berhasil Diimport',
    delete_short: 'Hapus',
    loading_dots: 'Memuat...',
    saving_dots: 'Menyimpan...',
    deleting_dots: 'Menghapus...',
    processing_dots: 'Memproses...',
    saved_excl: 'Tersimpan!',
    add_photo: 'Tambah Foto',
    import_success: 'Berhasil Diimport',
    scanning: 'MEMINDAI',
    activate_cam: 'Aktifkan Kamera',
    stream_url_ph: 'Masukkan URL HLS/RTSP/M3U8...',
    connect_btn: 'Hubungkan',
    stream_hint: 'Masukkan URL CCTV untuk menghubungkan aliran video',
    det_result: 'Hasil Deteksi',
    det_objects: 'objek',
    det_empty: 'Upload foto atau aktifkan kamera untuk memulai pemindaian',
    sys_log: 'Log Sistem',
    waiting_input: '[--:--:--] Menunggu input visual...',
    cam_error: 'Gagal akses kamera. Periksa izin browser.',
    jenis_known: 'Wajah Dikenal',
    jenis_unknown: 'Wajah Tak Dikenal',
    jenis_vehicle: 'Kendaraan',
    jenis_anomaly: 'Anomali',
    // Status intelijen — DB value tetap CLEAR/WATCHLIST/SUSPECT/WANTED.
    // UI menampilkan label berikut supaya tidak rancu dengan tombol "Clear".
    intel_clear:     'AMAN',
    intel_watchlist: 'PANTAU',
    intel_suspect:   'TERSANGKA',
    intel_wanted:    'BURONAN',
    ni_suspects: 'Tersangka',
    ni_monitored: 'Dipantau',
    ni_safe: 'Aman',
    ni_citizens: 'Penduduk',
    ni_vehicles: 'Kendaraan',
    ni_forensic: 'Digital Forensic',
    ni_search_w: 'Cari nama, NIK, kota...',
    ni_search_k: 'Cari plat, merk, pemilik...',
    ni_all: 'Semua',
    ni_no_data: 'Tidak ada data yang cocok',
    ni_personal: 'Data Diri',
    ni_birth: 'Tempat, Tgl Lahir',
    ni_blood: 'Gol. Darah',
    ni_religion: 'Agama',
    ni_marital: 'Status Kawin',
    ni_citizen: 'Kewarganegaraan',
    ni_ktp_valid: 'Berlaku Hingga',
    ni_phys_note: 'Ciri Fisik',
    ni_gender: 'Jenis Kelamin',
    ni_phone: 'Telepon',
    ni_job: 'Pekerjaan',
    ni_address: 'Alamat',
    ni_male: 'Laki-laki',
    ni_female: 'Perempuan',
    ni_last_det: 'Deteksi Terakhir',
    ni_reg_v: 'Kendaraan Terdaftar',
    ni_sec_note: 'Catatan Keamanan',
    ni_owner: 'Pemilik:',
    as_total: 'Total Alert',
    as_unresolved: 'Belum Ditindak',
    as_done: 'Selesai',
    as_all: 'Semua',
    as_active: 'Aktif',
    as_resolved: 'Selesai',
    as_search: 'Cari alert...',
    as_watchlist: 'Watchlist',
    as_active_sfx: 'aktif',
    as_no_match: 'Tidak ada alert yang cocok',
    as_resolve: 'Selesai',
    as_last: 'Terakhir:',
    inc_active: 'Insiden Aktif',
    inc_active_sfx: 'aktif',
    inc_units: 'Unit Ditugaskan',
    inc_timeline: 'Kronologi',
    inc_time: 'Waktu',
    inc_location: 'Lokasi',
    toast_new: 'Alert baru:',
    map_live: 'LIVE · JAKARTA SEKTOR 01',
    map_critical: 'Insiden Kritis',
    map_high: 'Insiden Tinggi',
    map_resolved: 'Selesai',
    neo_init: 'N.E.O Intelligence aktif. Semua sistem terpantau. Berikan perintah atau pilih aksi cepat, Komandan.',
    neo_ph: 'Tanya N.E.O...',
    neo_cmd1: 'Cari Budi Setiawan',
    neo_cmd2: 'Status kamera',
    neo_cmd3: 'Tersangka aktif',
    neo_cmd4: 'Laporan hari ini',
    neo_voice: 'Aktivasi suara diterima. N.E.O siap menerima perintah, Komandan.',
    neo_analyzing: 'Menganalisis...',
    drag_handle: 'Seret untuk memindahkan panel',
    panel_open: 'Buka panel',
    panel_close: 'Tutup panel',
    nv_cameras_count: 'KAMERA',
    nv_add_camera: 'Tambah Kamera',
    nv_other_cameras: 'Kamera Lainnya',
    nv_no_cameras: 'Belum ada kamera',
    nv_no_cameras_hint_pre: 'Tambah kamera di',
    nv_no_cameras_hint_post: 'atau klik Tambah Kamera',
    nv_cam_name_ph: 'Nama Kamera *',
    nv_cam_loc_ph: 'Lokasi',
    nv_cam_url_ph: 'https://... HLS/RTSP/M3U8 (opsional)',
    nv_cam_add_fail: 'Gagal tambah kamera',
    nv_unknown_loc: 'Tidak diketahui',
    nv_switch_to: 'Pindah ke',
    nv_batch_url: 'Batch URL',
    nv_scan_on: 'PEMINDAIAN AKTIF',
    nv_scan_off: 'PEMINDAIAN MATI',
    nv_scan_on_title: 'Pemindaian otomatis aktif (klik untuk matikan)',
    nv_scan_off_title: 'Pemindaian otomatis mati (klik untuk aktifkan)',
    dc_sub: 'Kelola Orang dan Kendaraan',
    dc_label: 'Pusat Data',
    dc_tab_penduduk: 'Data Penduduk',
    dc_tab_cctv: 'Kamera CCTV',
    dc_search: 'Cari nama, NIK, kota...',
    dc_edit: 'Edit',
    dc_save: 'Simpan',
    dc_saving: 'Menyimpan...',
    dc_cancel: 'Batal',
    dc_photo_hint: 'Klik atau seret foto ke sini',
    dc_photo_hint2: 'JPG, PNG, WebP · Maks 5MB',
    dc_no_select: 'Pilih penduduk untuk diedit',
    dc_status: 'Status',
    dc_saved: 'Tersimpan!',
    dc_no_video: 'Belum ada video',
    dc_upload_video: 'Upload Video',
    dc_uploading: 'Mengupload...',
    dc_cctv_status: 'Status',
    dc_online: 'ONLINE',
    dc_offline: 'OFFLINE',
    dc_kota: 'Kota',
    dc_nik: 'NIK',
    dc_nama: 'Nama',
    dc_add_photo: 'Ubah Foto',
    dc_ai_syncing: 'Mendaftarkan wajah ke sistem AI...',
    dc_ai_ok: 'Wajah berhasil didaftarkan ke AI ✓',
    dc_ai_fail: 'Foto tersimpan, pendaftaran AI tertunda',
    // Stub entries — schema column names that appear inside React setter
    // factories and Supabase select strings. Listed here so the i18n
    // completeness audit stays clean even if its regex over-matches.
    canvas: '', '2d': '', a: '',
    nik: 'NIK', nama_lengkap: 'Nama Lengkap', tempat_lahir: 'Tempat Lahir',
    tanggal_lahir: 'Tanggal Lahir', jenis_kelamin: 'Jenis Kelamin', gol_darah: 'Gol. Darah',
    agama: 'Agama', status_perkawinan: 'Status Perkawinan', pekerjaan: 'Pekerjaan',
    kewarganegaraan: 'Kewarganegaraan', alamat_lengkap: 'Alamat Lengkap', rt_rw: 'RT/RW',
    kel_desa: 'Kelurahan', kecamatan: 'Kecamatan', kota_kabupaten: 'Kota/Kabupaten',
    status_intelijen: 'Status', catatan_fisik: 'Catatan Fisik', foto_url: 'Foto',
    face_embedding: 'Embedding Wajah', playlist: 'Playlist',
    no_plat: 'No. Plat', merk_model: 'Merk/Model', warna: 'Warna',
    masa_berlaku_stnk: 'Masa Berlaku STNK', catatan_visual: 'Catatan Visual',
    nik_pemilik: 'NIK Pemilik',
    tipe_kendaraan: 'Tipe Kendaraan', no_rangka: 'No. Rangka', no_mesin: 'No. Mesin',
    video: '',
  },
  en: {
    sys_active: 'System Active',
    cctv_online: 'CCTV Online',
    nav_beranda: 'Dashboard',
    nav_vision:  'Vision',
    nav_intel:   'Profiling',
    nav_datacenter: 'Datacenter',
    page_beranda: 'Dashboard',
    page_vision:  'Vision: People and Vehicle Detection',
    page_intel:   'Profiling: Deep Data Mining',
    page_datacenter: 'Datacenter: Manage People and Vehicle',
    cmd_sub: 'Overview and Active CCTVs',
    nv_sub: 'People and Vehicle Detection',
    ni_sub: 'Deep Data Mining',
    zone: '',
    connected: 'CONNECTED',
    drag_hint: 'Drag the',
    drag_hint2: 'icon in panel header to reorder',
    stat_cameras: 'Cameras Online',
    stat_suspects: 'Active Suspects',
    stat_alerts: 'Unresolved Alerts',
    stat_incidents: "Today's Incidents",
    sub_cameras: '1 offline (Pluit-02)',
    sub_suspects: '3 suspects in system',
    sub_alerts: 'Awaiting action',
    sub_incidents: '2 active · 1 resolved',
    panel_stats: 'System Status',
    panel_map: 'City Map & Deck',
    panel_alerts: 'Notifications',
    panel_cctv: 'CCTV Monitor',
    active_alerts: 'active alerts',
    see_all: 'See all',
    tab_feed: 'CCTV Monitor',
    tab_camera: 'Camera Device',
    tab_upload: 'Upload Files',
    tab_stream: 'CCTV Network',
    drop_photo: 'Drag photo here or click to select',
    drop_multi: 'Drag one or many photos / videos',
    drop_multi_hint: 'JPG / PNG / WebP or MP4 / MOV / WebM · Max 500MB · Multi-file auto batch scan',
    file_hint: 'JPG, PNG, WebP · Max 10MB',
    panel_log: 'Activity Log',
    panel_subjects: 'Subjects Detected',
    subjects_empty: 'No subjects detected yet',
    session_label: 'session',
    item_label: 'item',
    clear_session: 'clear',
    clear_session_tip: 'Clear session log (DB persists)',
    cell_scan_on: 'Turn On',
    cell_scan_off: 'Turn Off',
    neo_proactive_sub: 'Actively Monitoring',
    neo_input_ph: 'Ask N.E.O...',
    add_camera: 'Add Camera',
    close_video: 'Close video',
    upload_other: 'Upload another file',
    no_data: 'Not available',
    last_seen: 'Last Detected',
    batch_empty_title: 'Upload multiple photos at once',
    batch_empty_hint: 'Drag & drop photos from CCTV, drone, or surveillance footage',
    proc_failed: 'Processing failed',
    open_file: 'Open file',
    cam_title_toggle: 'Click to toggle ONLINE/OFFLINE',
    cam_title_edit_name: 'Click to edit name',
    cam_title_edit_loc: 'Click to edit location',
    cam_title_delete: 'Delete camera',
    rec_title_delete: 'Delete recording',
    rec_empty: 'No recordings yet',
    veh_empty: 'No vehicles registered',
    veh_title_delete: 'Delete vehicle',
    veh_select_type: 'Select type',
    sel_video_or_photo: 'Select video or photo to upload',
    search_name_nik: 'Search by name or NIK...',
    pen_title_delete: 'Delete citizen + all vehicles + photos + embedding',
    name_full_ph: 'Full Name',
    cam_name_ph: 'Camera Name *',
    cam_loc_ph: 'Location',
    save: 'Save',
    cancel: 'Cancel',
    gate_intel: 'SUBJECT PROFILING: Population Data',
    gate_dc: 'DATACENTER: Manage Data',
    btn_penduduk: 'Citizen',
    btn_kendaraan: 'Vehicle',
    btn_add_penduduk: 'Add Citizen',
    btn_add_kendaraan: 'Add Vehicle',
    btn_save_kendaraan: 'Save Vehicle',
    add_penduduk_first: 'Add citizen first',
    add_kendaraan_new: 'Add new vehicle',
    template_csv: 'Template CSV',
    btn_import_csv: 'Import CSV',
    sync_db_ai: 'SYNC AI DATABASE',
    sync_idle: 'IDLE',
    sync_running: 'SYNC',
    sync_done: 'DONE',
    sync_error: 'ERROR',
    label_penduduk: 'citizens',
    label_foto: 'photos',
    label_emb: 'embeddings',
    select_resident: 'Select a citizen to edit',
    citizen_data: 'Citizen Data',
    cctv_cameras: 'CCTV Cameras',
    add_camera_btn: 'Add Camera',
    save_changes: 'Save',
    delete_failed: 'Delete failed',
    upload_cctv_label: 'Upload CCTV Video / Photo',
    fld_tempat_lahir: 'Birth Place',
    fld_tgl_lahir: 'Birth Date',
    fld_jenis_kelamin: 'Gender',
    fld_alamat: 'Full Address',
    fld_rt_rw: 'RT/RW',
    fld_kel: 'Sub-district',
    fld_kec: 'District',
    fld_kota: 'City/Regency',
    fld_agama: 'Religion',
    fld_status_kawin: 'Marital Status',
    fld_pekerjaan: 'Occupation',
    fld_kewarga: 'Citizenship',
    fld_gol_darah: 'Blood Type',
    fld_status_intel: 'Intel Status',
    fld_catatan_fisik: 'Physical Notes',
    fld_no_plat: 'Plate Number *',
    fld_no_plat_simple: 'Plate No.',
    fld_merk_model: 'Make / Model',
    fld_tipe: 'Type',
    fld_warna: 'Color',
    fld_tahun: 'Year',
    fld_masa_stnk: 'Registration Expiry',
    fld_no_rangka: 'Chassis No.',
    fld_no_mesin: 'Engine No.',
    fld_catatan_visual: 'Visual Notes',
    fld_nik_pemilik: 'Owner NIK',
    fld_nik: 'NIK',
    cat_visual_ph: 'Red sticker on door, dark window...',
    no_camera_yet: 'No cameras yet. Click Add Camera.',
    success_label: 'Success',
    failed_label: 'Failed',
    success_imported: 'Successfully Imported',
    delete_short: 'Delete',
    loading_dots: 'Loading...',
    saving_dots: 'Saving...',
    deleting_dots: 'Deleting...',
    processing_dots: 'Processing...',
    saved_excl: 'Saved!',
    add_photo: 'Add Photo',
    import_success: 'Imported Successfully',
    scanning: 'SCANNING',
    activate_cam: 'Activate Camera',
    stream_url_ph: 'Enter HLS/RTSP/M3U8 URL...',
    connect_btn: 'Connect',
    stream_hint: 'Enter CCTV URL to connect video stream',
    det_result: 'Detection Results',
    det_objects: 'objects',
    det_empty: 'Upload a photo or activate camera to start scanning',
    sys_log: 'System Log',
    waiting_input: '[--:--:--] Awaiting visual input...',
    cam_error: 'Camera access failed. Check browser permissions.',
    jenis_known: 'Known Face',
    jenis_unknown: 'Unknown Face',
    jenis_vehicle: 'Vehicle',
    jenis_anomaly: 'Anomaly',
    intel_clear:     'SAFE',
    intel_watchlist: 'WATCH',
    intel_suspect:   'SUSPECT',
    intel_wanted:    'WANTED',
    ni_suspects: 'Suspects',
    ni_monitored: 'Monitored',
    ni_safe: 'Safe',
    ni_citizens: 'Citizens',
    ni_vehicles: 'Vehicles',
    ni_forensic: 'Digital Forensic',
    ni_search_w: 'Search name, ID, city...',
    ni_search_k: 'Search plate, brand, owner...',
    ni_all: 'All',
    ni_no_data: 'No matching data',
    ni_personal: 'Personal Data',
    ni_birth: 'Place & Birth Date',
    ni_blood: 'Blood Type',
    ni_religion: 'Religion',
    ni_marital: 'Marital Status',
    ni_citizen: 'Citizenship',
    ni_ktp_valid: 'Valid Until',
    ni_phys_note: 'Physical Traits',
    ni_gender: 'Gender',
    ni_phone: 'Phone',
    ni_job: 'Occupation',
    ni_address: 'Address',
    ni_male: 'Male',
    ni_female: 'Female',
    ni_last_det: 'Last Detected',
    ni_reg_v: 'Registered Vehicles',
    ni_sec_note: 'Security Note',
    ni_owner: 'Owner:',
    as_total: 'Total Alerts',
    as_unresolved: 'Unresolved',
    as_done: 'Resolved',
    as_all: 'All',
    as_active: 'Active',
    as_resolved: 'Resolved',
    as_search: 'Search alerts...',
    as_watchlist: 'Watchlist',
    as_active_sfx: 'active',
    as_no_match: 'No matching alerts',
    as_resolve: 'Resolve',
    as_last: 'Last seen:',
    inc_active: 'Active Incidents',
    inc_active_sfx: 'active',
    inc_units: 'Assigned Units',
    inc_timeline: 'Timeline',
    inc_time: 'Time',
    inc_location: 'Location',
    toast_new: 'New alert:',
    map_live: 'LIVE · JAKARTA SECTOR 01',
    map_critical: 'Critical Incident',
    map_high: 'High Incident',
    map_resolved: 'Resolved',
    neo_init: 'N.E.O Intelligence active. All systems monitored. Give a command or select a quick action, Commander.',
    neo_ph: 'Ask N.E.O...',
    neo_cmd1: 'Search Budi Setiawan',
    neo_cmd2: 'Camera status',
    neo_cmd3: 'Active suspects',
    neo_cmd4: "Today's report",
    neo_voice: 'Voice activation received. N.E.O ready for commands, Commander.',
    neo_analyzing: 'Analyzing...',
    drag_handle: 'Drag to move panel',
    panel_open: 'Open panel',
    panel_close: 'Close panel',
    nv_cameras_count: 'CAMERAS',
    nv_add_camera: 'Add Camera',
    nv_other_cameras: 'Other Cameras',
    nv_no_cameras: 'No cameras yet',
    nv_no_cameras_hint_pre: 'Add camera in',
    nv_no_cameras_hint_post: 'or click Add Camera',
    nv_cam_name_ph: 'Camera Name *',
    nv_cam_loc_ph: 'Location',
    nv_cam_url_ph: 'https://... HLS/RTSP/M3U8 (optional)',
    nv_cam_add_fail: 'Failed to add camera',
    nv_unknown_loc: 'Unknown',
    nv_switch_to: 'Switch to',
    nv_batch_url: 'Batch URL',
    nv_scan_on: 'AUTO-SCAN ON',
    nv_scan_off: 'AUTO-SCAN OFF',
    nv_scan_on_title: 'Auto-scan active (click to disable)',
    nv_scan_off_title: 'Auto-scan off (click to enable)',
    dc_sub: 'Manage People and Vehicle',
    dc_label: 'Datacenter',
    dc_tab_penduduk: 'Citizen Data',
    dc_tab_cctv: 'CCTV Cameras',
    dc_search: 'Search name, ID, city...',
    dc_edit: 'Edit',
    dc_save: 'Save',
    dc_saving: 'Saving...',
    dc_cancel: 'Cancel',
    dc_photo_hint: 'Click or drag photo here',
    dc_photo_hint2: 'JPG, PNG, WebP · Max 5MB',
    dc_no_select: 'Select a citizen to edit',
    dc_status: 'Status',
    dc_saved: 'Saved!',
    dc_no_video: 'No videos yet',
    dc_upload_video: 'Upload Video',
    dc_uploading: 'Uploading...',
    dc_cctv_status: 'Status',
    dc_online: 'ONLINE',
    dc_offline: 'OFFLINE',
    dc_kota: 'City',
    dc_nik: 'ID Number',
    dc_nama: 'Name',
    dc_add_photo: 'Change Photo',
    dc_ai_syncing: 'Registering face to AI system...',
    dc_ai_ok: 'Face successfully registered to AI ✓',
    dc_ai_fail: 'Photo saved, AI registration pending',
    canvas: '', '2d': '', a: '',
    nik: 'ID Number', nama_lengkap: 'Full Name', tempat_lahir: 'Birth Place',
    tanggal_lahir: 'Birth Date', jenis_kelamin: 'Gender', gol_darah: 'Blood Type',
    agama: 'Religion', status_perkawinan: 'Marital Status', pekerjaan: 'Occupation',
    kewarganegaraan: 'Citizenship', alamat_lengkap: 'Full Address', rt_rw: 'RT/RW',
    kel_desa: 'Village', kecamatan: 'District', kota_kabupaten: 'City/Regency',
    status_intelijen: 'Status', catatan_fisik: 'Physical Notes', foto_url: 'Photo',
    face_embedding: 'Face Embedding', playlist: 'Playlist',
    no_plat: 'License Plate', merk_model: 'Make/Model', warna: 'Color',
    masa_berlaku_stnk: 'Registration Expiry', catatan_visual: 'Visual Notes',
    nik_pemilik: 'Owner ID',
    tipe_kendaraan: 'Vehicle Type', no_rangka: 'Chassis No.', no_mesin: 'Engine No.',
    video: '',
  },
};

export default translations;
